import { message } from 'antd';
import { useCallback } from 'react';
import {
  deleteAdminProductImage,
  uploadAdminProductMaterialImages,
} from '../../services';
import type { FetchAdminProductsOptions } from '../interfaces';
import { getApiErrorMessage } from '../../utils/apiError';

type UseAdminProductMediaActionsArgs = {
  activeSearchTerm: string;
  fetchProducts: (options?: FetchAdminProductsOptions) => Promise<void>;
};

export const useAdminProductMediaActions = ({
  activeSearchTerm,
  fetchProducts,
}: UseAdminProductMediaActionsArgs) => {
  const handleUploadMaterialImages = useCallback(async (
    productId: string,
    materialPriceId: string,
    files: Blob[]
  ) => {
    if (!files.length) {
      return;
    }

    try {
      await uploadAdminProductMaterialImages(productId, materialPriceId, files);
      message.success('Material images uploaded.');
      await fetchProducts({ append: false, skip: 0, search: activeSearchTerm });
    } catch (error) {
      message.error(getApiErrorMessage(error, 'Failed to upload material images.'));
    }
  }, [activeSearchTerm, fetchProducts]);

  const handleDeleteMaterialImage = useCallback(async (imageId: string) => {
    try {
      await deleteAdminProductImage(imageId);
      message.success('Material image deleted.');
      await fetchProducts({ append: false, skip: 0, search: activeSearchTerm });
    } catch (error) {
      message.error(getApiErrorMessage(error, 'Failed to delete material image.'));
    }
  }, [activeSearchTerm, fetchProducts]);

  return { handleDeleteMaterialImage, handleUploadMaterialImages };
};
